<filter-sorting>

    <!-- Normal View -->
    <div class="d-none d-lg-block mr-2">
        <a href="#" class="btn btn-sm menu-login-btn" data-toggle="dropdown">
            <i class="fa fa-sliders mr-2"></i>Filters & Sorting
        </a>
        <div class="dropdown-menu aero-filter-dropdown">
            <h4 class="dropdown-header">Filters</h4>
            <a class="dropdown-item" href="#" onclick="{onSelect}">
                <input type="checkbox" ref="type" name="photo" onchange="{onFilter}" id="photo_type">
                <label for="photo_type">Photos</label>
            </a>
            <a class="dropdown-item" href="#">
                <input type="checkbox" ref="type" name="footage" onchange="{onFilter}" id="footage_type">
                <label for="footage_type">Stock Footage</label>
            </a>
            <a class="dropdown-item" href="#">
                <input type="checkbox" ref="type" name="recording" onchange="{onFilter}" id="recording_type">
                <label for="recording_type">Recordings</label>
            </a>
            <div class="dropdown-divider"></div>
            <h4 class="dropdown-header">Sorting</h4>
            <a class="dropdown-item" href="#">Date</a>
        </div>
    </div>

    <!-- Mobile View -->
    <div class="d-lg-none mr-2" style="display: initial;">
        <a href="#" data-toggle="dropdown" id="filter-dropdown">
            <i class="fa fa-sliders"></i>
        </a>

        <div class="dropdown-menu w-100" aria-labelledby="filter-dropdown">
            <h4 class="dropdown-header">Filters</h4>
            <a class="dropdown-item" href="#"  onchange="{onFilter}">
                <input type="checkbox"  ref="type" name="photo">
                <label>Photos</label>
            </a>
            <a class="dropdown-item" href="#"  onchange="{onFilter}">
                <input type="checkbox" name="footage" ref="type">
                <label>Stock Footage</label>
            </a>
            <a class="dropdown-item" href="#"  onchange="{onFilter}">
                <input type="checkbox" name="recording" ref="type">
                <label>Recordings</label>
            </a>
            <div class="dropdown-divider"></div>
            <h4 class="dropdown-header">Sorting</h4>
            <a class="dropdown-item" href="#">Date</a>
        </div>
    </div>


    <script>
        const filterSorting = this;

        filterSorting.onSelect = (event) => {
            event.preventUpdate = true;
            event.stopPropagation();
        };

        filterSorting.onFilter = (event) => {
            event.preventUpdate = true;

            let activeFilters = filterSorting.refs.type.filter(
                item => item.checked
            ).map(
                item => item.name
            );

            if (opts.onFilter)
                opts.onFilter(activeFilters);
            else
                console.log('Filtering for: ', activeFilters)
        }
    </script>
</filter-sorting>


// WEBPACK FOOTER //
// avr_eshop/frontend/components/nav-bar/filter-sorting.tag.html